import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

interface Props {
  actions?: React.ReactNode;
  children: React.ReactNode;
  lastSlideIndex?: number;
  renderBackIcon?: boolean;
  renderCloseIcon?: boolean;
  resetIndex?: number;
  slideTitle?: string;
  slideSubtitle?: string;
  onSetOpen?: (status: boolean) => void;
  setSlideIndex: (slideIndex: number) => void;
}

function SlideContent({
  actions,
  children,
  lastSlideIndex = 0,
  renderBackIcon = false,
  renderCloseIcon = false,
  resetIndex = 0,
  slideTitle,
  slideSubtitle,
  onSetOpen,
  setSlideIndex,
}: Props) {
  const classes = useStyles();

  const handleClose = () => {
    onSetOpen && onSetOpen(false);
    setSlideIndex(resetIndex);
  };

  const shouldRenderTitleContainer =
    slideTitle || slideSubtitle || renderBackIcon || renderCloseIcon;

  return (
    <div className={classes.slide} data-testid="slide-content">
      {shouldRenderTitleContainer && (
        <div className={classes.slideTitleContainer} data-testid="slide-title-container">
          <div className={classes.slideTitle}>
            {renderBackIcon && (
              <IconButton aria-label="Back" onClick={() => setSlideIndex(lastSlideIndex)}>
                <ArrowBackIcon />
              </IconButton>
            )}
            <div>
              <Typography variant="h5">{slideTitle}</Typography>
              {slideSubtitle && <Typography variant="subtitle2">{slideSubtitle}</Typography>}
            </div>
          </div>
          {renderCloseIcon && (
            <IconButton aria-label="Close" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          )}
        </div>
      )}
      <div className={classes.slideContent}>{children}</div>
      {actions && (
        <div className={classes.slideFooter} data-testid="slide-actions">
          {actions}
        </div>
      )}
    </div>
  );
}

const useStyles = makeStyles((theme: any) => ({
  slide: {
    padding: theme.spacing(3),
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  slideTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    marginBottom: theme.spacing(2),
  },
  slideTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  slideContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
  },
  flexAlignCenter: {
    display: 'flex',
    flexDirection: 'column',
  },
  slideFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(2),
    },
  },
}));

export default SlideContent;
